/*
 * @Author: Src
 * @Date: 2025-07-15 09:56:56
 * @LastEditTime: 2026-03-17 14:58:33
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/carRouter/carShopRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';

import ShopList from '@/views/carModule/shop/shopList.vue';
import ShopDetail from '@/views/carModule/shop/shopDetail.vue';
import carMarket from '@/views/carModule/shop/carMarket.vue';
import { AuthEnum } from '@/services/permission.service';


const carShopRoutes: RouteConfig = {
  path: '/carshop',
  component: Main,
  redirect: {
    name: ' car.index',
  },
  meta: {
    title: '店铺管理',
  },
  children: [
    {
      name: 'car.index',
      path: '/carshop/list',
      component: ShopList,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车店铺列表],
      },
      meta: {
        title: '店铺列表',
      },
    },
    {
      name: 'car.detail',
      path: '/carshop/detail/:id',
      component: ShopDetail,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车店铺列表],
      },
      meta: {
        title: '店铺详情',
      },
    },
    {
      name: 'car.market',
      path: '/carshop/market',
      component: carMarket,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车市场管理],
      },
      meta: {
        title: '二手车市场',
      },
    },
  ],
};

export default carShopRoutes;
